module.exports = __webpack_public_path__ + "static/Flowspring Logo Reverse_ISS MI-8570f3373919d81b8926579e69ad3541.png";